import Chart from 'chart.js';
import * as Config from '../config';
import forEach from 'lodash/forEach';

export default class Timeline {
    constructor({el}) {
        this.el = el;
    
        this.bind();

        this.setupCharts();
    }

    getChartOptions(type, chartOptions) {
        const options = {
            title: {
                display: false
            },
            legend: {
                display: false
            },
            scales: {
                xAxes: [{
                    gridLines: false,
                    ticks: {
                        beginAtZero: true,
                        padding: 10,
                        lineHeight: 1.5
                    }
                }],
                yAxes: [{
                    ticks: {
                        beginAtZero: true
                    },
                    display: false
                }]
            }
        };

        if (type === 'horizontalBar') {
            options.scales = {
                yAxes: [{
                    gridLines: false,
                    ticks: {
                        beginAtZero: true,
                        padding: 10,
                        lineHeight: 1.5
                    }
                }],
                xAxes: [{
                    ticks: {
                        beginAtZero: true
                    },
                    display: false
                }]
            };
        }

        return options;
    }

    setupCharts() {
        const charts = this.el.querySelectorAll('.chart');

        forEach(charts, ctx => {
            let type = ctx.getAttribute('data-type');
            const labels = ctx.getAttribute('data-labels').split(',');
            const options = JSON.parse(ctx.getAttribute('data-options'));
            const data = ctx.getAttribute('data-values').split(',');
            const backgroundColor = Object.values(Config.get('colors'));

            if (type === 'bar' && options.horizontal) {
                type = 'horizontalBar';
            }

            const myChart = new Chart(ctx, {
                type,
                data: {
                    labels,
                    datasets: [{
                        label: `Water (litres)`,
                        data,
                        backgroundColor,
                        borderWidth: 0
                    }]
                },
                options: this.getChartOptions(type, options)
            });
        });
    }

    bind() {
        this.el.addEventListener('click', evt => {
            evt.preventDefault();
        
        });
    }
}